export default __webpack_public_path__ + "static/DSC_0421-44297e803056e2239a16284533a87b0c.jpg";